export const manageHostUsers = state => state.administration.manageHostUsers;
